import { useCallback, useMemo } from 'react'

import { useGetProjects } from 'src/hooks/useGetProjects'
import { useGetUsers } from 'src/hooks/useGetUsers'
import { MyReviewingConfirmationTranslator } from 'src/translators'
import { useGetMyReviewingConfirmationsQuery } from 'src/types/generated'

type Input = {
  isEnabledPolling?: boolean
}

export const useGetMyReviewingConfirmations = (input?: Input) => {
  const { loading, data, error, refetch } = useGetMyReviewingConfirmationsQuery({
    // NOTE: 5分ごとにポーリングする。0を設定することでポーリングを停止する
    pollInterval: input?.isEnabledPolling ? 1000 * 5 * 60 : 0,
  })

  const { users } = useGetUsers()
  const { projects } = useGetProjects()

  const myReviewingConfirmations = useMemo(() => {
    return data
      ? MyReviewingConfirmationTranslator.toEntities({
          internalUsers: users,
          projects,
          response: data.myReviewingConfirmations,
        })
      : []
  }, [data, projects, users])

  const getReviewingApplicationCountByProjectId = useCallback(
    (projectId: string) => {
      return myReviewingConfirmations.filter(confirmation => confirmation.project.id === projectId)
        .length
    },
    [myReviewingConfirmations]
  )

  return {
    loading,
    myReviewingConfirmations,
    getReviewingApplicationCountByProjectId,
    error,
    refetch,
  }
}
